var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVehicleRepairStand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 15.989999999999998 4.980163508769255",
    width: 15.989999999999998,
    height: 4.980163508769255,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-163946483691962030",
    d: "M4 18.01 C4 18.01 4 18.01 4 18.01 C4 18.55 4.45 19 4.99 19 C4.99 19 11 19 11 19 C11 19 11 21.009999999999998 11 21.009999999999998 C11 21.56 11.45 21.999999999999996 11.99 21.999999999999996 C11.99 21.999999999999996 12 21.999999999999996 12 21.999999999999996 C12.55 21.999999999999996 12.99 21.549999999999997 12.99 21.009999999999998 C12.99 21.009999999999998 12.99 19 12.99 19 C12.99 19 19 19 19 19 C19.55 19 19.99 18.55 19.99 18.01 C19.99 18.01 19.99 18.01 19.99 18.01 C19.99 17.46 19.54 17.020000000000003 19 17.020000000000003 C19 17.020000000000003 4.99 17.020000000000003 4.99 17.020000000000003 C4.45 17.01 4 17.46 4 18.01 Z",
    vectorEffect: "non-scaling-stroke"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4, -17.01983649123074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 18.01 C4 18.01 4 18.01 4 18.01 C4 18.55 4.45 19 4.99 19 C4.99 19 11 19 11 19 C11 19 11 21.009999999999998 11 21.009999999999998 C11 21.56 11.45 21.999999999999996 11.99 21.999999999999996 C11.99 21.999999999999996 12 21.999999999999996 12 21.999999999999996 C12.55 21.999999999999996 12.99 21.549999999999997 12.99 21.009999999999998 C12.99 21.009999999999998 12.99 19 12.99 19 C12.99 19 19 19 19 19 C19.55 19 19.99 18.55 19.99 18.01 C19.99 18.01 19.99 18.01 19.99 18.01 C19.99 17.46 19.54 17.020000000000003 19 17.020000000000003 C19 17.020000000000003 4.99 17.020000000000003 4.99 17.020000000000003 C4.45 17.01 4 17.46 4 18.01 Z",
    style: {
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      fill: "rgb(74, 74, 74)"
    },
    vectorEffect: "non-scaling-stroke"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleRepairStand);
export default __webpack_public_path__ + "static/media/VehicleRepairStand.569189ec40f54574da0db85e0e3d8232.svg";
export { ForwardRef as ReactComponent };